// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2uCEj","buttons":"PendingPaymentAlert_buttons__1Pw_2"};